import React, { Component } from 'react';
import { images } from '../../../../settings';
import { BrowserRouter as Router, Link } from 'react-router-dom';

import './Cross.scoped.scss';

class Cross extends Component {
  constructor(props) {
    super(props);
    this.images = images;
  }
  render() {
    return (
      <div className="planos-template">
        <div className="planos-template--risca" style={{ backgroundColor: this.props.cor }}></div>
        <div className="planos-template__conteudo">
          {/* <h3 className="h2 h2--500 planos-template__titulo" style={{ color: this.props.cor }}>
            Liquidez
          </h3> */}
          <h4 className="planos-template__subtitulo">
            As iniciativas relacionadas a investimento crossborder se deram em duas frentes:
          </h4>
          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_cross1} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Facilitar investimento estrangeiro</h5>
                <p>
                  Após a divulgação das novas regras para BDRs (Brazilian Depositary Receipts), foi realizada conversa
                  com a CVM para reforçar a necessidade de uma revisão mais ampla das normas para investimento no
                  exterior. O objetivo é reduzir assimetrias e permitir a evolução da indústria. Em setembro, enviamos
                  ofício à CVM com nossas propostas para ajustes na ICVM 555 que permitam aumento dos limites para
                  investimento no exterior.
                </p>
                <p>
                  Dentro de casa, desenvolvemos um estudo, com apoio da PwC, para identificar alterações regulatórias
                  necessárias para atrair o investimento estrangeiro no Brasil e facilitar as aplicações no mercado
                  externo. O levantamento foi enviado para o BC e para a CVM. Também retomamos a discussão sobre a
                  identificação do beneficiário final dos investimentos de não residentes, iniciada em 2019.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_cross2} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Projeto de lei de câmbio</h5>
                <p>
                  Foram discutidos os aspectos do projeto de lei relacionados ao mercado de capitais, incluindo
                  alterações às normas infralegais. Apresentamos nossos pontos em reunião com o BC.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="planos-template__footer">
          <a
            className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
            href="https://www.anbima.com.br/data/files/B5/B5/1F/15/375FE610DC784BE6192BA2A8/Relatorio_de_Iniciativas_2019.pdf "
            target="_blank"
          >
            Saiba mais no Relatório de Iniciativas
          </a>
        </div> */}
      </div>
    );
  }
}
export { Cross };
